import api from './api';

/**
 * Service for Budget Management
 * Tracks position and dollar allocations per program per term
 */
export const budgetService = {
    async getBudget(program, term) {
        const response = await api.get('/budget', {
            params: { program, term },
        });
        return response.data;
    },

    async getSummaryByTerm(term) {
        const response = await api.get('/budget/summary', {
            params: { term },
        });
        return response.data;
    },

    async getHistory(params = {}) {
        const response = await api.get('/budget/history', { params });
        return response.data;
    },

    async createBudget(data) {
        const response = await api.post('/budget', data);
        return response.data;
    },

    async updateBudget(id, data) {
        const response = await api.put(`/budget/${id}`, data);
        return response.data;
    },

    async addAdjustment(id, data) {
        const response = await api.post(`/budget/${id}/adjust`, data);
        return response.data;
    },
};

export default budgetService;
